// GOLDORA — Sentry instrumentation. Runs once at app boot.
// Disabled if REACT_APP_SENTRY_DSN env var is not set (fails gracefully).
import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    release: process.env.REACT_APP_SENTRY_RELEASE || "goldora-frontend@1.0.0",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: true,
      }),
    ],
    // Capture 10% of normal sessions, 100% of error sessions
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
    tracePropagationTargets: [
      /^\/api/,
      /^https:\/\/.*\.preview\.emergentagent\.com\/api/,
      /^https:\/\/goldora\.global\/api/,
    ],
    // Ignore noisy quota rejections (handled by QuotaModal)
    ignoreErrors: [
      /Quota/i,
      /402/,
      // Browser extension noise
      /chrome-extension:/,
      /moz-extension:/,
      /Non-Error promise rejection captured/i,
    ],
    beforeSend(event, hint) {
      // Drop known transient network errors that aren't actionable
      const err = hint?.originalException;
      const msg = String(err?.message || "");
      if (msg.includes("Failed to fetch") || msg.includes("NetworkError")) {
        return null;
      }
      return event;
    },
  });
  // eslint-disable-next-line no-console
  console.info("[goldora] Sentry initialized");
}

export { Sentry };
